var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.235,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 511.53
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.235,
    style: {
      fill: "#41479B"
    },
    width: 255.76,
    height: 255.76
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M128.656,170.141l-6.179,18.529l-19.532,0.152c-2.529,0.02-3.578,3.247-1.543,4.749l15.712,11.603   l-5.892,18.623c-0.762,2.411,1.982,4.406,4.039,2.935l15.89-11.357l15.89,11.357c2.057,1.471,4.803-0.524,4.039-2.935   l-5.892-18.623l15.712-11.603c2.034-1.503,0.986-4.73-1.543-4.749l-19.532-0.152l-6.179-18.529   C132.849,167.743,129.455,167.743,128.656,170.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M129.132,25.668l-4.999,14.989l-15.799,0.123c-2.045,0.016-2.893,2.627-1.248,3.841l12.71,9.386   l-4.766,15.064c-0.617,1.95,1.604,3.564,3.268,2.374l12.854-9.187l12.854,9.187c1.664,1.19,3.884-0.424,3.268-2.374l-4.766-15.064   l12.71-9.386c1.645-1.215,0.797-3.825-1.248-3.841l-15.799-0.123l-4.999-14.989C132.524,23.727,129.78,23.727,129.132,25.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M209.058,70.258l-4.999,14.989L188.26,85.37c-2.045,0.016-2.893,2.627-1.248,3.841l12.71,9.386   l-4.766,15.064c-0.617,1.95,1.604,3.564,3.268,2.374l12.854-9.187l12.854,9.187c1.664,1.19,3.884-0.424,3.268-2.374l-4.766-15.064   l12.71-9.386c1.645-1.215,0.797-3.825-1.248-3.841l-15.799-0.123l-4.999-14.989C212.45,68.318,209.706,68.318,209.058,70.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M50.889,87.926l-4.999,14.989l-15.799,0.123c-2.045,0.016-2.893,2.627-1.248,3.841l12.71,9.386   l-4.766,15.064c-0.617,1.95,1.604,3.564,3.268,2.374l12.854-9.188l12.854,9.188c1.664,1.19,3.884-0.424,3.268-2.374l-4.766-15.064   l12.71-9.386c1.645-1.215,0.797-3.825-1.248-3.841l-15.799-0.123l-4.999-14.989C54.282,85.985,51.536,85.985,50.889,87.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M174.608,136.857l-2.806,8.414l-8.87,0.069c-1.148,0.009-1.624,1.475-0.7,2.157l7.135,5.269   l-2.676,8.456c-0.347,1.095,0.9,2,1.834,1.333l7.216-5.157l7.216,5.157c0.934,0.667,2.181-0.238,1.834-1.333l-2.676-8.456   l7.135-5.269c0.924-0.682,0.448-2.148-0.7-2.157l-8.87-0.069l-2.806-8.414C176.513,135.768,174.972,135.768,174.608,136.857z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWs);
export default __webpack_public_path__ + "static/media/ws.c9ef3141dbb31f1560aece6fc1a6bf0b.svg";
export { ForwardRef as ReactComponent };